// The report is CSV, so it goes around the API client (which always parses JSON).
// `start` and `end` are optional, independent, inclusive dates (YYYY-MM-DD) over
// the delivery date; `env` picks the PDP environment the proxy reads from.
export const getPdpOmmBillableReport = ({ env, start, end } = {}) => {
  const params = new URLSearchParams()
  if (env) params.append('env', env)
  if (start) params.append('start', start)
  if (end) params.append('end', end)
  const query = params.toString()

  return fetch(
    `${window._api.backend}/contextual-similarity-models-apa/billable-report.csv${
      query ? `?${query}` : ''
    }`,
    {
      method: 'GET',
      headers: {
        Accept: 'text/csv',
        Authorization: `Bearer ${window._api.token}`,
      },
    }
  ).then((response) => {
    if (!response.ok) {
      throw new Error(`Report request failed with status ${response.status}`)
    }
    return response.text()
  })
}
